/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button[_ngcontent-%COMP%]{font-size:18px;margin-top:8px;background-color:#228b22;color:#fff}.firebasespinner[_ngcontent-%COMP%]{text-align:center}table[_ngcontent-%COMP%], td[_ngcontent-%COMP%], th[_ngcontent-%COMP%]{border:1px solid #000;margin-left:auto;margin-right:auto}"];
export { styles as styles };
